export default __webpack_public_path__ + "static/media/chat.f7580c14.svg";